var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('k8s.text_242')}}),_c('page-body',[_c('job-list',{attrs:{"id":_vm.listId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }